import type {
  CreateMediaData,
  ObservationResultSearch,
  ObservationResultsResponse,
  PathologyReportGetAllParams,
  PathologyReportGetAllResponse,
  PathologyReportGetResponse,
} from '@quromedical/models';
import { trpcClient } from 'trpc';

export class DiagnosticReportApi {
  getDiagnosticReports = async (
    params: PathologyReportGetAllParams,
  ): Promise<PathologyReportGetAllResponse> =>
    await trpcClient.pathologyReport.getAll.query(params);

  getDiagnosticReport = async (
    id: string,
  ): Promise<PathologyReportGetResponse> =>
    await trpcClient.pathologyReport.getById.query({ id });

  getPresentedForm = async (id: string): Promise<CreateMediaData[]> =>
    await trpcClient.pathologyReport.getPresentedForm.query({ id });

  getDiagnosticResults = async (
    params: ObservationResultSearch,
  ): Promise<ObservationResultsResponse> =>
    await trpcClient.patient.getObservation.query(params);
}
